import { BasicModel } from "../basic/basic.model";
import { SocieteModel } from "./societe.model";

export class SeuilModel extends BasicModel  {
    idSociete: number;
    societe: SocieteModel;
    codeCa1: string;
    seuil1: number;
    seuil2: number;
    seuil3: number;
    seuil4: number;
    type: string;
}
